import { FC } from 'react';

import styles from './index.module.scss';

import cn from 'classnames';

interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  type?: 'submit' | 'button';
  onClick?: () => void;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({ children, type, className, onClick, disabled }) => {
  return (
    <button
      className={cn(className, styles.button)}
      type={type ? type : 'button'}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export { Button };
